import { HttpClient, serializeJSONApiData } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const patchBrandSetting = (brandSetting, params) =>
  HttpClient().patch(
    `/brand_settings/v2/${brandSetting.id}`,
    serializeJSONApiData('brand_setting', params)
  )

const updateBrandSetting = (brandSetting, params) => (dispatch) =>
  patchBrandSetting(brandSetting, params)
    .then((response) => dispatch(loadJsonApiEntities(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default updateBrandSetting
